import React from "react";
import { Link } from "react-router-dom";
import "./CSS/Shopehero.css";
import bannerImg from "./Images/Rectangle 1.png"; 

const Shop = () => {
  return (
    <div className="shop-banner">
      <img src={bannerImg} alt="shop-banner" />

      <div className="overlay">
        <h1>Shop</h1>
        <p>
          <Link to="/">Home</Link> <span>›</span> <span className="active">Shop</span>
        </p>
      </div>
    </div>
  );
};

export default Shop;